import React, { useEffect } from 'react'
import BigAd from '../components/BigAd'
import { products } from '../data'
import { HomePath } from '../home-path'

export default function Post() {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
  return (
    <>
    <div className="h-fit w-full py-12">
        <div className="mxw">
            <div className="w-full h-fit py-4 text-left">
                <p className="max-w-3xl pb-8 mx-auto text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">From proper running attire, to trendy street clothes. Let's get you fitted.</p>
            </div>
            <section>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
                <p className="text-md md:text-lg lg:text-xl text-gray-600">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur excepturi neque minus? Lorem ipsum dolor sit amet, consectetur adipisiiat labore hic numquam assumenda harum reprehenderit incidunt ipsam iure, blanditiis cum?</p>
                <p className="text-md md:text-lg lg:text-xl text-gray-600">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur excepturi neque minus? Lorem ipprehenderit incidunt ipsam iure, blanditiis cum?</p>
                </div>
                {/* <div className="my-6 grid grid-cols-4 grid-rows-1 grid-flow-dense gap-2 "> */}
                <div className="my-6 grid gap-2 md:gap-4 grid-cols-2">
                    {/* <img className="col-span-2 h-full w-full object-cover" src={products[3]?.img} alt="" />
                    <img className="col-span-2 h-full w-full object-cover" src={products[5]?.img} alt="" />
                    <img className="col-span-full h-full w-full object-cover" src={products[1]?.img} alt="" /> */}
                        {/* <img className="col-span-2 h-full w-full object-cover" src={products[3]?.img} alt="" />
                        <img className="col-span-2 row-span-2 h-full w-full object-cover" src={products[5]?.img} alt="" />
                        <img className="col-span-2 h-full w-full object-cover" src={products[1]?.img} alt="" /> */}
                        <div className="grid grid-cols-1 gap-2">
                            <img className=" h-full w-full object-cover" src={products[3]?.img} alt="" />
                            <img className=" h-full w-full object-cover" src={products[9]?.img} alt="" />
                        </div>
                        <div className="grid grid-cols-1 gap-2">
                            <img className=" h-full w-full object-cover" src={products[5]?.img} alt="" />
                            <img className=" h-full w-full object-cover" src={products[1]?.img} alt="" />
                        </div>
                    </div>
                {/* </div> */}

                <div className="my-6 py-6">
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">Some Points</h2>
                    <ul className="py-4 text-md md:text-lg lg:text-xl list-inside list-disc space-y-4">
                        <li>Proper fit</li>
                        <li>Good materials</li>
                        <li>Comfort</li>
                        <li>Longevity</li>
                    </ul>
                </div>

                <div className="my-6">
                <p className="text-md md:text-lg lg:text-xl text-gray-600">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur excepturi neque minus? Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto dolorum necessitatibus veritatis similique consequuntur! Libero minus fuga earum, aut voluptatibus possimus! Facere, rem officiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe doloribus reprehenderit dolorem, nesciunt quibusdam porro aliquam, ab quidem, distinctio dolorum repellendus possimus recusanda.</p>
                </div>
            </section>
        </div>
    </div>
    <BigAd dark route={HomePath + "/workout-info"} minorHeading="Discover" majorHeading="Get Active!" text="Checkout workout info here" buttonText="Visit"/>
    </>
  )
}
